import { PlayIcon } from "@heroicons/react/20/solid"

const PlayButton = () => (
  <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-white drop-shadow-md transition duration-300 ease-in-out hover:scale-110 hover:drop-shadow-xl active:text-slate-400">
    <PlayIcon className="h-16 w-16 " />
  </div>
)

export default PlayButton
